export const PACKAGE_NAME = 'jiraIssueRealtimeUpdates';
export const TEAM_NAME = 'jira-yurree';
export const MAX_ALLOWED_QUEUE_SIZE = 100;
export const QUERY_ISSUE_DETAILS_DELAY_TIME = 3000;
